// src/components/Navbar4.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const Navbar4 = ({ title, backPath, projectId, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backPath, { state: { projectId } });
    }
  };

  return (
    <nav className="flex items-center justify-between p-6 border-b">
      <div className="text-2xl font-bold text-black">
        {title}
      </div>
      <button
        onClick={handleBack}
        className="text-gray-600 hover:text-black transition-colors duration-200"
      >
        <XCircle size={24} />
      </button>
    </nav>
  );
};

export default Navbar4;